import React from 'react';
import TableInstance from '../Table/Table';
import Figure from '../figures/Figure';

/* eslint-disable react/prop-types */
export const ShowAttachment = props => {
  let showComponent;
  if (props && props.expanded) {
    showComponent =
      props.item.attachmentType === 'FIGURE' ? (
        <Figure
          selectedFigure={{
            year: props.content.year,
            shortName: props.content.shortName,
            label: props.item.label
          }}
        />
      ) : (
        <TableInstance
          selectedTable={{
            year: props.content.year,
            shortName: props.content.shortName,
            label: props.item.label
          }}
        />
      );
  }
  return showComponent ? (
    <div className="mt-4 mb-3">{showComponent}</div>
  ) : null;
};

export default ShowAttachment;
